import IndexMain from "@/components/layout/index";
import login from "@/views/login/login";
import Index from "@/views/index/index";
//系统管理
import MenuList from "@/views/menu/list"; //菜单管理
import MenuEdit from "@/views/menu/edit"; //菜单管理
import RoleList from "@/views/role/list"; //角色列表
import RoleEdit from "@/views/role/edit"; //角色编辑
import UserList from "@/views/user/list"; //管理员列表
import UserListWechat from "@/views/user/listwechat"; //管理员小程序列表
import templatepdfList from "@/views/templatepdf/list"; //管理员列表
import templatepdfEdit from "@/views/templatepdf/edit"; //管理员列表
import UserEdit from "@/views/user/edit"; //管理员修改
import Password from "@/views/user/password"; //管理员修改密码
//基础管理
import Template from "@/views/template/list"; //模板管理
import TemplateDetail from "@/views/template/template"; //模板管理demo
import Device from "@/views/device/list"; //设备管理
import Carbrand from "@/views/carbrand/list"; //车辆管理
import Insurance from "@/views/insurance/list"; //保单
//保单服务
import Saleman from "@/views/saleman/list"; //销售人员列表
import Saleslip from "@/views/saleslip/list"; //销售单据
import SaleslipEdit from "@/views/saleslip/edit"; //销售编辑
import SaleslipAdd from "@/views/saleslip/add"; //销售新增
import Salevoidrecord from "@/views/salevoidrecord/list"; //销售单作废


export default [
  {
    path: "/login/login",
    name: "login",
    component: login
  },
  {
    path: "/",
    name: "layout",
    component: IndexMain,
    redirect: "/index/index",
    children: [
      {
        path: "/index/index",
        name: "index",
        meta: {
          title: "首页"
        },
        component: Index
      },
      {
        path: "/menu/list",
        name: "menulist",
        meta: {
          title: "菜单管理",
          keepAlive: true
        },
        component: MenuList
      },
      {
        path: "/menu/edit",
        name: "MenuEdit",
        meta: {
          title: "菜单编辑"
        },
        component: MenuEdit
      },
      {
        path: "/role/list",
        name: "rolelist",
        meta: {
          title: "角色管理",
          keepAlive: true
        },
        component: RoleList
      },
      {
        path: "/role/edit",
        name: "roleedit",
        meta: {
          title: "角色编辑"
        },
        component: RoleEdit
      },
      {
        path: "/user/list",
        name: "userlist",
        meta: {
          title: "用户管理",
          keepAlive: true
        },
        component: UserList
      },
      {
        path: "/user/listwechat",
        name: "UserListWechat",
        meta: {
          title: "小程序用户管理",
          keepAlive: true
        },
        component: UserListWechat
      },
      {
        path: "/templatepdf/list",
        name: "templatepdflist",
        meta: {
          title: "车行模板配置",
          keepAlive: true
        },
        component: templatepdfList
      },
      {
        path: "/templatepdf/edit",
        name: "templatepdfedit",
        meta: {
          title: "模板配置编辑"
        },
        component: templatepdfEdit
      },
      {
        path: "/user/password",
        name: "Password",
        meta: {
          title: "修改密码"
        },
        component: Password
      },
      {
        path: "/user/edit",
        name: "useredit",
        meta: {
          title: "用户编辑"
        },
        component: UserEdit
      },
      {
        path: "/template/list",
        name: "Template",
        meta: {
          title: "用户编辑",
          keepAlive: true
        },
        component: Template
      },
      {
        path: "/device/list",
        name: "Device",
        meta: {
          title: "设备管理",
          keepAlive: true
        },
        component: Device
      },
      {
        path: "/carbrand/list",
        name: "Carbrand",
        meta: {
          title: "车辆管理",
          keepAlive: true
        },
        component: Carbrand
      },
      {
        path: "/insurance/list",
        name: "Insurance",
        meta: {
          title: "保单管理",
          keepAlive: true
        },
        component: Insurance
      },
      {
        path: "/saleman/list",
        name: "Saleman",
        meta: {
          title: "销售人员",
          keepAlive: true
        },
        component: Saleman
      },
      {
        path: "/saleslip/list",
        name: "Saleslip",
        meta: {
          title: "销售单",
          keepAlive: true
        },
        component: Saleslip
      },
      {
        path: "/saleslip/edit",
        name: "SaleslipEdit",
        meta: {
          title: "销售单编辑"
        },
        component: SaleslipEdit
      },
      {
        path: "/saleslip/add",
        name: "SaleslipAdd",
        meta: {
          title: "销售单新增"
        },
        component: SaleslipAdd
      },
      {
        path: "/salevoidrecord/list",
        name: "Salevoidrecord",
        meta: {
          title: "作废销售单列表",
          keepAlive: true
        },
        component: Salevoidrecord
      },
      {
        path: "/template/TemplateDetail",
        name: "TemplateDetail",
        meta: {
          title: "打印模板"
        },
        component: TemplateDetail
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/routers.js